'use strict';

module.exports = require('./is-implemented')() ? Map : require('./polyfill');



//////////////////
// WEBPACK FOOTER
// ../~/es6-map/index.js
// module id = 82
// module chunks = 0